import { render } from "./BuilderLocationsTable.vue?vue&type=template&id=3a7de768"
import script from "./BuilderLocationsTable.vue?vue&type=script&lang=js"
export * from "./BuilderLocationsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__